import React, { useContext } from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJs,
  ArcElement,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
  LineElement,
  PointElement,
} from "chart.js";
import annotationPlugin from "chartjs-plugin-annotation";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { Card } from "react-bootstrap";
import LoadingSpinner from "../LoadingSpinner.js";
import { useAPI } from "../../ApiContext.js";

import {
  EQUIPMENT_AND_SOFTWARE_SELECTION_LIST,
  QUESTION_4,
} from "../../constants/constants.js";
import { ColorPaletteContext } from "../../App.js";
import { getEquipmentAndSoftwareSelectionDataQ4 } from "../../Helper.js";

ChartJs.register(
  Tooltip,
  Legend,
  ArcElement,
  BarElement,
  CategoryScale,
  LinearScale,
  LineElement,
  PointElement,
  annotationPlugin,
  ChartDataLabels
);

function EquipmentAndSoftwareSelectionBarChartQ4(props) {
  const { dashboardData } = useAPI();
  const colorPaletteContext = useContext(ColorPaletteContext);

  const { colorPaletteState } = colorPaletteContext;

  function getChartData() {
    return {
      labels: EQUIPMENT_AND_SOFTWARE_SELECTION_LIST.map((item) => item.value),
      datasets: [
        {
          label: "",
          data: EQUIPMENT_AND_SOFTWARE_SELECTION_LIST.map((item) =>
            getEquipmentAndSoftwareSelectionDataQ4(
              item.key,
              dashboardData.data,
              {
                countryFilterValue: props.countryFilterValue,
                roleFilterValue: props.roleFilterValue,
              }
            )
          ),
          borderColor: colorPaletteState[0],
          backgroundColor: colorPaletteState[0],
          borderWidth: 1,
          hoverOffset: 4,
        },
      ],
    };
  }

  function getChartOption() {
    return {
      responsive: true,
      maintainAspectRatio: false,
      layout: {
        padding: 30,
      },
      plugins: {
        tooltip: {
          callbacks: {
            title: (context) => {
              return context[0].label.replaceAll(",", " ");
            },
          },
        },
        legend: {
          display: false,
        },
        datalabels: {
          formatter: (value) => {
            return value + " %";
          },
          anchor: "end",
          align: "top",
          color: "grey",
          font: {
            weight: "bold",
            size: 12,
          },
        },
      },
      scales: {
        x: {
          grid: {
            display: false,
          },
          ticks: {
            font: {
              //weight: "bold",
              size: 10,
            },
          },
        },
        y: {
          grid: {
            display: false,
          },
          display: false,
        },
      },
    };
  }

  return (
    <Card>
      <Card.Header>{QUESTION_4}</Card.Header>
      <Card.Body>
        {dashboardData.data && dashboardData.data.length > 0 ? (
          <div style={{ width: "100%", height: "80vh" }}>
            <Bar options={getChartOption()} data={getChartData()} />
          </div>
        ) : (
          <LoadingSpinner />
        )}
      </Card.Body>
    </Card>
  );
}
export default EquipmentAndSoftwareSelectionBarChartQ4;
